import styled, { css } from 'styled-components'
import { Link } from 'react-router-dom'
import { Text } from 'ui'
import React from 'react'

const BaseStyles = css`
  ${({children, theme, props}) => props};

  display: ${({ $isInline }) => $isInline
    ? 'inline-block'
    : 'unset'
  };

  text-decoration-line: underline;
  -webkit-text-decoration-line: underline;

  text-decoration-color: ${({ theme }) => theme.colors.neutral[600]} !important;
  -webkit-text-decoration-color: ${({ theme }) => theme.colors.neutral[600]} !important;

  text-underline-offset: 2px;
  transition: text-decoration 200ms;

  &:hover {
    text-decoration-color: ${({ theme }) => theme.colors.basics.white} !important;
    -webkit-text-decoration-color: ${({ theme }) => theme.colors.basics.white} !important;
    border: 0px solid rgba(1,1,1,0); // hack to color change in safari
  }
`
const LinkStyled = styled(Link)`
  border: 0px solid transparent; // hack to color change in safari
  ${BaseStyles}
`

const ButtonStyled = styled.button`
  border: none;
  background-color: ${({ theme }) => theme.colors.basics.transparent};
  color: ${({ theme }) => theme.colors.basics.white};
  cursor: pointer;

  ${BaseStyles}
`

const TextLink = ({
  children,
  isInline,
  size = 'base',
  weight = 'medium',
  color = 'headline',
  onClick,
  to,
  openNewTab,
}) => {

  const Container = onClick
    ? ButtonStyled
    : LinkStyled

  const props = onClick
    ? { onClick, type: 'button' }
    : { to }

  const linkProps = openNewTab
    ? { target:"_blank", rel:"noopener noreferrer" }
    : {}
  
  return (
    <Container $isInline={isInline} {...props} {...linkProps}>
      <Text size={size} weight={weight} color={color} as={isInline ? 'span' : 'p'}>
        { children }
      </Text>
    </Container>
  )
}

export default React.memo(TextLink)